import { useState } from "react";
import { Form, Modal, Row, Col, Radio, Button } from "antd";
import LogOutIcon from "../assets/images/logout-icon.svg";
import lang from "../helper/langHelper";
import { AuthContext } from "../context/AuthContext";

const DeleteModal = ({ show, hide, onOk, title, subtitle, reasons }) => {
  return (
    <Modal
      width={415}
      open={show}
      footer={false}
      onOk={onOk}
      okText={lang("Ok")}
      cancelText={lang("Cancel")}
      onCancel={hide}
      centered
      className="tab_modal"
    >
      <div className="modal-inner-body">
        <img className="check-tital-icon" src={LogOutIcon} />
        <h6 className="">{title}</h6>
        <p className="">{subtitle}</p>
        <Button className="modal-fill-btn" type="primary" onClick={onOk}>
          Yes, Confirm
        </Button>
      </div>
    </Modal>
  );
};

export default DeleteModal;
